"use client";

import React from "react";
import PropTypes from "prop-types";
import styles from "../css/components/modal.module.css"; // Adjust the import path as needed

const Modal = ({ onClose, children, closeStyle, contentClassName, showCloseButton = true }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={`${styles.modalOverlay} ${styles.show}`} onClick={handleOverlayClick}>
      <div className={`${styles.modalContent} ${contentClassName || ""}`.trim()}>
        {children}
        {showCloseButton ? (
          <button
            className={`${styles.closeButton} ${closeStyle === 'plain' ? styles.closePlain : ''}`}
            onClick={onClose}
          >
            ✕
          </button>
        ) : null}
      </div>
    </div>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  closeStyle: PropTypes.oneOf(["plain", undefined]),
  contentClassName: PropTypes.string,
  showCloseButton: PropTypes.bool,
};

export default Modal;